module.exports = __webpack_public_path__ + "media/images/info-close-53de522abb3c5399b261b25d7b821498.svg";